/* eslint-disable react/no-multi-comp */
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

export const PrivateRoutePhoneNumber = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      rest.phoneNo ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export const PrivateRouteAuth = ({ component: Component, ...rest }) => {
  const hasLoginSession = useSelector(state => state.auth.hasLoginSession);

  return (
    <Route
      {...rest}
      render={props => {
        return rest.token && hasLoginSession ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location }
            }}
          />
        );
      }}
    />
  );
};

export const PrivateRouteNik = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      rest.nik ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);
